var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _path4, _path5, _circle5, _circle6, _circle7, _circle8, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 137,
    viewBox: "0 0 122 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7006 90.1909L51.6929 134.39H59.4171",
    stroke: "#B29785",
    strokeWidth: 3.43297,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.545 49.4242L101.71 86.2256L96.3749 97.4546",
    stroke: "#B29785",
    strokeWidth: 3.43297,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1493 89.7618L70.5745 134.39H78.2987",
    stroke: "#B29785",
    strokeWidth: 3.43297,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.9615,
    cy: 32.903,
    r: 3.21841,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.9615,
    cy: 32.903,
    r: 4.36785,
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 2.29887
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.2141,
    cy: 32.903,
    r: 3.21841,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.2141,
    cy: 32.903,
    r: 4.36785,
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 2.29887
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6497 85.2159C29.5598 82.8578 27.3334 75.882 25.5612 69.4908C22.6525 58.4819 22.2131 46.484 24.6032 39.1123C26.1508 34.0424 30.3549 27.4718 33.6338 24.8331C37.8349 21.5002 44.5876 20.3232 46.9769 22.5016C48.3642 23.7664 49.6553 23.7497 51.4998 22.3615C57.3582 18.1519 71.5569 21.2053 85.6533 29.4525C100.289 38.1916 105.959 48.8185 105.005 66.0269C104.478 77.9967 101.761 83.876 94.6717 88.4986C89.3336 91.9887 81.1191 93.3679 75.9605 91.7346C72.3929 90.5286 72.0681 90.5735 68.2963 94.98C63.4234 100.429 58.6636 102.059 50.898 100.948C43.9362 99.8877 33.5423 91.7758 30.6497 85.2159Z",
    fill: "#E8B89F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2251 84.5271L32.2191 84.5133L32.2127 84.4996C31.1911 82.2892 28.9999 75.4536 27.2225 69.0449C24.3593 58.2021 23.9918 46.5733 26.2405 39.6377L26.2451 39.6236L26.2494 39.6095C26.966 37.2616 28.3257 34.4927 29.9236 31.9753C31.5311 29.443 33.2816 27.3198 34.7105 26.1684C36.5606 24.7022 39.022 23.6818 41.2813 23.2874C42.4062 23.091 43.42 23.0607 44.2361 23.1742C45.0701 23.2902 45.5636 23.5358 45.8145 23.7646C46.7073 24.5785 47.7904 25.174 49.1128 25.1383C50.3583 25.1047 51.4872 24.5147 52.5203 23.7399C54.8291 22.0917 59.1958 21.666 65.1318 22.9114C70.955 24.1331 77.8525 26.8762 84.7744 30.9251C91.9091 35.1862 96.7158 39.8212 99.6537 45.3633C102.593 50.9085 103.753 57.5335 103.287 65.9333L103.287 65.943L103.286 65.9527C103.027 71.8456 102.232 76.0532 100.735 79.3051C99.262 82.5051 97.0534 84.8986 93.7293 87.0662L93.7275 87.0673C91.2914 88.6602 88.1357 89.8055 84.9575 90.3502C81.7715 90.8963 78.7316 90.8106 76.4981 90.1075C76.4501 90.0913 76.402 90.075 76.3539 90.0587C74.7933 89.5296 73.2003 88.9896 71.5477 89.6702C70.7434 90.0015 70.0492 90.5642 69.3758 91.225C68.7008 91.8874 67.9306 92.7674 66.9993 93.8552C64.6986 96.4249 62.5287 97.9796 60.1221 98.8048C57.7012 99.6349 54.8706 99.7852 51.1507 99.2539C48.092 98.7855 44.0341 96.6945 40.3079 93.795C36.5834 90.8968 33.5091 87.4388 32.2251 84.5271Z",
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 3.43297
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.2678,
    cy: 49.4243,
    r: 2.14561,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.2678,
    cy: 49.4243,
    r: 3.29504,
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 2.29887
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1452,
    cy: 49.4243,
    r: 2.14561,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1452,
    cy: 49.4243,
    r: 3.29504,
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 2.29887
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5498 47.1444C29.6266 41.8158 31.5787 38.3085 34.3289 36.5522C38.0784 34.172 38.1333 36.2687 34.5488 40.1637C32.2444 42.6676 31.077 45.0142 30.9612 47.2963C30.8454 49.5784 30.3002 50.7869 29.1633 50.9442C28.1888 51.079 27.9301 49.8199 28.5498 47.1444Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2496 63.5698C91.2391 57.4205 90.4384 54.1322 87.2649 48.3395C85.1208 44.5086 85.1927 41.5043 87.4278 43.5421C88.5839 44.5961 92.2141 52.5107 93.169 55.9396C94.0634 58.9721 93.9084 68.3816 92.9696 69.4017C91.6894 70.7928 91.1307 69.0896 91.2496 63.5698Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9502 70.0226C41.9897 75.3682 44.3069 77.8349 49.923 81.3114C53.6765 83.5882 55.0945 86.2378 52.1455 85.5662C50.6201 85.2187 43.5609 80.1209 41.0402 77.6079C38.7675 75.4099 34.2654 67.1459 34.5796 65.7956C35.008 63.9543 36.3334 65.161 38.9502 70.0226Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4612 89.203C51.0014 90.9972 53.0157 91.4682 56.8328 91.2149C59.364 91.0196 61.0819 91.9434 59.5686 92.7198C58.7859 93.1213 53.6781 93.0338 51.5595 92.6164C49.6781 92.2778 44.287 89.4273 43.8431 88.5519C43.2377 87.3582 44.303 87.5137 47.4612 89.203Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6894 79.6573C94.2449 76.6206 95.1635 74.7671 95.7889 70.9932C96.1769 68.4842 97.4688 67.0228 97.8789 68.6734C98.091 69.5272 96.839 74.4799 95.9487 76.4472C95.1893 78.2015 91.1827 82.7988 90.229 83.031C88.9286 83.3477 89.3233 82.3462 91.6894 79.6573Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5244 61.0106L20.9963 85.6971L25.1806 95.4311",
    stroke: "#B29785",
    strokeWidth: 3.43297,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.301 28.7519C27.3115 23.3059 28.9569 15.4177 36.1832 10.1271C37.6887 9.00871 39.0221 8.14844 39.1511 8.23447C39.2371 8.32049 38.721 9.09474 37.9898 9.912C36.2692 11.8906 35.581 14.0843 35.8821 16.8802C36.1402 19.461 37.8392 22.1709 38.549 23.0682C39.2588 23.9656 40.4845 25.5259 40.4845 25.5259C40.4845 25.698 41.0007 26.3432 41.6029 26.9884C42.6782 28.1067 42.6782 28.2788 42.2051 29.8273C41.904 30.7306 41.3018 32.193 40.8717 33.0533C39.9684 34.8168 35.495 39.4193 34.6347 39.4193C34.3336 39.4193 33.742 38.8757 33.0002 37.5853C32.2583 36.2949 31.2905 34.198 29.301 28.7519Z",
    fill: "#B29785"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7957 28.7519C97.7852 23.3059 96.1398 15.4177 88.9135 10.1271C87.408 9.00871 86.0746 8.14844 85.9456 8.23447C85.8595 8.32049 86.3757 9.09474 87.1069 9.912C88.8275 11.8906 89.5157 14.0843 89.2146 16.8802C88.9565 19.461 87.2575 22.1709 86.5477 23.0682C85.8379 23.9656 84.6121 25.5259 84.6121 25.5259C84.6121 25.698 84.096 26.3432 83.4938 26.9884C82.4185 28.1067 82.4185 28.2788 82.8916 29.8273C83.1927 30.7306 83.7949 32.193 84.225 33.0533C85.1283 34.8168 89.6017 39.4193 90.462 39.4193C90.7631 39.4193 91.3547 38.8757 92.0965 37.5853C92.8383 36.2949 93.8061 34.198 95.7957 28.7519Z",
    fill: "#B29785"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5079 20.4311C53.8387 20.2381 51.4785 21.7459 45.6302 16.207C43.4225 15.1272 40.7013 13.9786 39.6463 13.7162C37.9944 13.2463 37.6753 13.3438 37.2049 14.5239C36.527 16.301 38.4066 21.5443 40.6856 24.2337C41.6306 25.4121 43.603 26.964 45.1303 27.6977C47.8309 28.9951 52.5587 37.9644 65.8542 33.3322C69.8229 33.2581 73.2498 31.7444 76.4147 32.5317C81.5785 33.8162 82.4663 33.5654 83.1293 30.9002C83.8198 28.124 83.4997 27.2779 80.8326 24.9636C77.2903 21.9009 72.4318 20.5744 64.5079 20.4311Z",
    fill: "#E8D593"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4362 46.457C68.001 45.7913 69.7413 45.1172 71.4017 44.6818C73.0621 44.2464 74.7808 44.0135 75.5304 44.3345",
    stroke: "#B29785",
    strokeWidth: 3.43297,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9331 46.1205C56.3145 45.5045 54.6715 44.4206 52.9805 44.1259C51.2895 43.8312 49.4096 44.3011 48.6895 44.6838",
    stroke: "#B29785",
    strokeWidth: 3.43297,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9758 61.2459L65.9427 61.5956L66.158 61.873C67.3028 63.348 67.5941 64.6643 67.4452 65.6014C67.3 66.5154 66.7315 67.1588 65.8942 67.4081C64.9518 67.6889 63.742 67.5458 62.9171 66.9186C62.1692 66.3498 61.5736 65.2525 62.0574 63.2217L62.1758 62.7242L61.8045 62.3726C60.2884 60.9374 60.1865 59.6931 60.5014 58.8078C60.8486 57.8314 61.783 57.0498 62.7254 56.7691C63.4318 56.5587 64.2593 56.8595 64.9654 57.7393C65.6633 58.6087 66.1027 59.9075 65.9758 61.2459Z",
    fill: "#747070",
    stroke: "#B29785",
    strokeWidth: 1.77269
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorns);
export default __webpack_public_path__ + "static/media/horns.f2cf09d99dd32706edfd92bcf115ab1c.svg";
export { ForwardRef as ReactComponent };